import { Box, Button, Text } from '@chakra-ui/react'
import React from 'react'

interface CustomButtonProps {
  buttonText: string
  handlerFunction?: () => void
  buttonColor?: string
  buttonVariant?: string
  disabled?: boolean
  my?: string
  customeStyleWidth?: string
  isLoading?: boolean
  fontWeight?: string
  fontSize?: string
  width?: string
  frameColor?: string
}
const CustomButton = (props: CustomButtonProps) => {
  const {
    buttonText,
    handlerFunction,
    buttonColor,
    buttonVariant,
    my,
    disabled,
    customeStyleWidth,
    isLoading,
    fontWeight,
    fontSize,
    width,
    frameColor,
  } = props
  // console.log(buttonVariant)
  return (
    <Box width='full' my={my ?? '40px'}>
      <Text textAlign='center'>
        <Button
          py='20px'
          px='50px'
          rounded='3xl'
          fontWeight={fontWeight}
          fontSize={fontSize || 'md'}
          size='xs'
          width={width}
          onClick={handlerFunction}
          variant={buttonVariant ?? 'solid'}
          isDisabled={disabled}
          // disabled={disabled}
          paddingX={customeStyleWidth}
          isLoading={isLoading}
          colorScheme='primary'
          {...props}
          _hover={{ opacity: !disabled && '0.7' }}
        >
          {buttonText}
        </Button>
      </Text>
    </Box>
  )
}

export default CustomButton
